
document.addEventListener('DOMContentLoaded', () => {
  const navbarBurgers = Array.from(
    document.querySelectorAll('.navbar-burger')
  );

  const dropdowns = Array.from(
    document.querySelectorAll('.navbar-item.has-dropdown')
  );

  const closeDropdown = (dropdown) => {
    dropdown.classList.remove('is-active');

    const button = dropdown.querySelector('button.navbar-link');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  };

  const openDropdown = (dropdown) => {
    dropdown.classList.add('is-active');

    const button = dropdown.querySelector('button.navbar-link');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
  };

  const closeAllDropdowns = (except = null) => {
    dropdowns.forEach((dropdown) => {
      if (dropdown !== except) {
        closeDropdown(dropdown);
      }
    });
  };

  // Mobile burger navigation.
  navbarBurgers.forEach((burger) => {
    const target = document.getElementById(burger.dataset.target);

    if (!target) {
      return;
    }

    burger.setAttribute(
      'aria-expanded',
      String(burger.classList.contains('is-active'))
    );

    burger.addEventListener('click', () => {
      const isActive = burger.classList.toggle('is-active');

      target.classList.toggle('is-active', isActive);
      burger.setAttribute('aria-expanded', String(isActive));

      const cookieOverlay = document.querySelector('.cfGMLl');

      if (cookieOverlay) {
        cookieOverlay.classList.toggle('is-nav-active', isActive);
      }

      if (!isActive) {
        closeAllDropdowns();
      }
    });
  });

  // Accessible dropdown navigation.
  dropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector('button.navbar-link');

    if (!button) {
      return;
    }

    button.setAttribute(
      'aria-expanded',
      String(dropdown.classList.contains('is-active'))
    );

    button.addEventListener('click', (event) => {
      event.stopPropagation();

      const isExpanded = dropdown.classList.contains('is-active');

      closeAllDropdowns(dropdown);

      if (isExpanded) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });

    // Escape closes the dropdown and returns focus.
    dropdown.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (dropdown.classList.contains('is-active')) {
          event.preventDefault();
          event.stopPropagation();

          closeDropdown(dropdown);
          button.focus();
        }
      }
    });

    // Close when keyboard focus leaves the dropdown.
    dropdown.addEventListener('focusout', (event) => {
      const nextElement = event.relatedTarget;

      if (nextElement && !dropdown.contains(nextElement)) {
        closeDropdown(dropdown);
      }
    });
  });

  // Close dropdowns when clicking outside.
  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown(dropdown);
      }
    });
  });

  // Keyboard accessibility.
  document.addEventListener('keydown', (event) => {
    // Escape closes any open dropdown.
    if (event.key === 'Escape') {
      const openDropdowns = dropdowns.filter((dropdown) =>
        dropdown.classList.contains('is-active')
      );

      if (openDropdowns.length > 0) {
        event.preventDefault();

        const dropdown = openDropdowns[0];
        const button = dropdown.querySelector('button.navbar-link');

        closeAllDropdowns();

        if (button) {
          button.focus();
        }
      }

      return;
    }

    // Native buttons already support Enter and Space.
    // Keep support for the existing focusable div wrappers.
    if (event.key === 'Enter') {
      const activeElement = document.activeElement;

      if (!activeElement) {
        return;
      }

      if (
        activeElement.matches(
          '.nav-link-conatiner, .click-lang-switch'
        )
      ) {
        const link = activeElement.querySelector('a');

        if (link) {
          event.preventDefault();
          link.click();
        }
      }

      // Existing search keyboard functionality.
      if (activeElement.id === 'start-search') {
        event.preventDefault();

        const search = document.querySelector('#search');
        const input = document.querySelector('#search input');

        if (search) {
          search.classList.toggle('visible');
        }

        if (input) {
          input.focus();
        }
      }
    }
  });
});
